/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SkeletonBase from './SkeletonBase';

const isNumber = val => typeof val === 'number';

const getSize = value => isNumber(value) ? `${value}px` : value;

const SkeletonLoad = styled(SkeletonBase).withConfig({
  displayName: "SkeletonLoadWrapper__SkeletonLoad",
  componentId: "sc-1216nua-0"
})(["height:", ";width:", ";"], ({
  height
}) => getSize(height), ({
  width
}) => getSize(width));

const SkeletonLoadWrapper = (_ref) => {
  let {
    isLoading,
    isError,
    children = null,
    Content,
    contentProps,
    ErrorContent,
    errorContentProps,
    widths,
    heights,
    style,
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["isLoading", "isError", "children", "Content", "contentProps", "ErrorContent", "errorContentProps", "widths", "heights", "style", "className"]);

  if (isError) {
    return /*#__PURE__*/_jsx(ErrorContent, Object.assign({}, errorContentProps));
  }

  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      style: style,
      className: className,
      children: widths.map((width, index) => {
        return /*#__PURE__*/_jsx(SkeletonLoad, Object.assign({
          className: index ? 'm-top-1' : null,
          height: heights[index],
          width: width,
          use: "on-shade"
        }, rest), index);
      })
    });
  }

  if (Content) {
    return /*#__PURE__*/_jsx(Content, Object.assign({}, contentProps));
  }

  return children;
};

SkeletonLoadWrapper.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  className: PropTypes.string
};
SkeletonLoadWrapper.defaultProps = {
  isLoading: false,
  widths: ['100%'],
  heights: ['0.75em'],
  style: {}
};
export default SkeletonLoadWrapper;